export const CHUNK_RELOAD_KEY = 'chunk-load-error-reload';

/**
 * MPA 초기 로드 시 chunk 로드 실패를 감지하여 1회 리로드하는 인라인 스크립트.
 * _document.tsx의 <Head> 최상단에 <script dangerouslySetInnerHTML>로 삽입하여
 * React 마운트 전에 에러 핸들러를 등록한다.
 *
 * - window 'error' (capture phase): <script> 태그 로드 실패 감지
 * - window 'unhandledrejection': dynamic import 실패 감지
 * - sessionStorage 기반 URL당 1회 리로드로 무한 리로드 방지
 * - SPA 라우트 전환 에러는 useChunkLoadErrorHandler hook에서 처리
 */
export const chunkLoadErrorRecoveryScript = `
(function() {
  var KEY = '${CHUNK_RELOAD_KEY}';

  function tryReload() {
    try {
      var reloadedUrl = sessionStorage.getItem(KEY);
      if (reloadedUrl === location.href) {
        return;
      }
      sessionStorage.setItem(KEY, location.href);
      location.reload();
    } catch (e) {}
  }

  window.addEventListener('error', function(e) {
    var t = e.target;
    if (t && t.tagName === 'SCRIPT' && /\\/static\\/chunks\\//.test(t.src || '')) {
      tryReload();
    }
  }, true);

  window.addEventListener('unhandledrejection', function(e) {
    var reason = e.reason;
    var msg = (reason && reason.message) || String(reason || '');
    if (msg.indexOf('ChunkLoadError') !== -1 || msg.indexOf('Loading chunk') !== -1) {
      tryReload();
    }
  });
})();
`;
